// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PortalUser } from 'src/app/model/platformuser.model';
import { SubTenant } from 'src/app/model/subtenant';
import { AppEnvironmentService } from '../app-environment.service';

const contentType = 'application/json';

@Injectable({ providedIn: 'root' })
export class SubTenantService {

    constructor(private readonly http: HttpClient, private readonly appEnvironmentService: AppEnvironmentService) { }

    private get baseApiUrl(): string { return this.appEnvironmentService.baseApiUrl; }

    getSubTenants(tenantId: number): Observable<SubTenant[]> {
        const accessToken = localStorage.getItem('access_token');
        const apiUrl = this.baseApiUrl + `tenants/${tenantId}/subtenants`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        //@ts-ignore
        return this.http.get<SubTenant[]>(apiUrl, { headers }).pipe(
            map((subTenants) => subTenants.map((subTenant) => SubTenant.FromAPI(subTenant)))
        );
    }

    createSubTenant(tenantId: number, subTenant: SubTenant, user: PortalUser) {
        const accessToken = localStorage.getItem('access_token');
        const apiUrl = this.baseApiUrl + `tenants/${tenantId}/subtenants`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        const payload = {
            ...subTenant.toCreationAPIForm(user)
        };
        return this.http.post<SubTenant>(apiUrl, payload, { headers });
    }

    updateSubTenant(tenantId: number, subTenantId: number, creditLimit: number | null) {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/subtenants/${subTenantId}`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.put(url, { creditLimit }, { headers });
    }

    deleteSubTenant(subTenantId: number, tenantId: number): Observable<void> {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/subtenants/${subTenantId}`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.delete<void>(url, { headers });
    }
}
